// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"8461472f5c8e4481408c","811":"0ea429e8fcd9cd5c3944"}[chunkId] + ".js";
};